import { takeLatest, put, call } from 'redux-saga/effects';
import { history, storage } from '@commons';
import { createRomaneioColheita, updateRomaneioColheita } from '../service';
import {
  CONFIG_SESSION,
  CREATE_ROMANEIO_COLHEITA,
  CREATE_ROMANEIO_COLHEITA_PENDING,
  CREATE_ROMANEIO_COLHEITA_SUCCESS,
  CREATE_ROMANEIO_COLHEITA_FAILURE,
} from '@handler';
import {
  AlertSuccess,
  AlertError,
  AlertWarning,
} from '@components/common/AlertToast';
import { formatDateDDMMYYYY, isDateValidVerifyDateBetween } from '@components/common/format';

function* sagaCreateRomaneioColheita(action) {
  yield put({ type: CREATE_ROMANEIO_COLHEITA_PENDING });

  try {
    const safraAtiva = JSON.parse(storage.get(CONFIG_SESSION)).safraAtiva;
    var dateFrom = safraAtiva.dataInicial;
    var dateTo = safraAtiva.dataFinal;
    var dateCheck = action.data.data;

    if (!isDateValidVerifyDateBetween(dateFrom, dateTo, dateCheck)) {
      yield put({ type: CREATE_ROMANEIO_COLHEITA_FAILURE, registro: action.data });

      AlertWarning('Data informada fora do período da safra ativa. Período deve ser entre '
        + formatDateDDMMYYYY(dateFrom) + ' até ' + formatDateDDMMYYYY(dateTo) + '!');
    } else {

      if (action.data.talhao.talhao !== undefined && action.data.talhao.talhao !== null) {
        action.data.talhao = action.data.talhao.talhao;
      }

      if (action.data.id === undefined || action.data.id === null) {
        yield call(createRomaneioColheita, {
          ...action.data,
          propriedade: {
            id: JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id
          },
          safra: {
            id: JSON.parse(storage.get(CONFIG_SESSION)).safraAtiva.id
          }
        });
      } else {
        yield call(updateRomaneioColheita,
          {
            ...action.data,
            id: action.data.id
          }
        );
      }

      yield put({ type: CREATE_ROMANEIO_COLHEITA_SUCCESS, registro: action.data });

      history.push('/agricultura/romaneioColheita');
      AlertSuccess('Registro salvo com sucesso!');
    }
  } catch (error) {
    yield put({ type: CREATE_ROMANEIO_COLHEITA_FAILURE, registro: action.data });
    AlertError('Falha ao salvar o registro! Tente novamente...');
  }
}

export default function* watchCreateRomaneioColheita() {
  yield takeLatest(CREATE_ROMANEIO_COLHEITA, sagaCreateRomaneioColheita);
}
